import React, { ReactElement } from "react"

import { ReportTableData } from "../../interfaces/dataInterfaces"

type Props = {
  showDetails: ReportTableData | null
}

function ReportDataDetails({ showDetails }: Props): ReactElement {
  return (
    <>
      <p>
        <b>Number of observations:</b> {showDetails?.observations || showDetails?.commodityPriceObservations}
      </p>
      <p className="mt-1">
        <b>Metadata:</b>
      </p>

      {showDetails && showDetails?.commodityPriceMetadata?.length > 0 && (
        <div>
          {showDetails?.commodityPriceMetadata?.map((meta: any, i) => (
            <p key={i} className="text-sm">
              {Object.keys(meta).map((key: string) => (
                <span key={key}>
                  <b>{key}</b>: {meta[key]} |{" "}
                </span>
              ))}
            </p>
          ))}
        </div>
      )}

      {showDetails && showDetails?.metadata?.length > 0 && (
        <div className="compact-table">
          <table className="table text-lg">
            <tbody className="custom-tbody">
              <tr>
                <th className="p-2 font-bold">RowID</th>
                <th className="p-2 font-bold">ObsPriceValue</th>
              </tr>

              {showDetails?.metadata?.map(meta => (
                <tr key={meta?.rowID}>
                  <td className="p-1 text-center"> {meta?.rowID}</td>
                  <td
                    className={`p-1 text-center ${
                      showDetails.isDuplicated && showDetails.isPriceInvalid ? "bg-red-500" : ""
                    }`}
                  >
                    {meta?.obsPriceValue}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  )
}

export default ReportDataDetails
